module.exports = __webpack_public_path__ + "static/media/quiz-tab.e626dec3.png";